<template>
    <VueElementLoading spinner="bar-fade-scale" :color="spinnerColor" :active="props.isActive" :is-full-screen="true" />
</template>

<script>
import VueElementLoading from 'vue-element-loading';
import ENV from "../../../config/env";

export default {
    name: "LoadingComponent",
    components: { VueElementLoading },
    props: ['props'],
    data() {
        return {
            isActive: false
        }
    },
    computed: {
        spinnerColor: function () {
            return ENV.LOADER_COLOR;
        },
    }
}
</script>